const MINUTE_SECONDS = 60
const HOUR_SECONDS = 3600

// «12 ч 05 мин» / «45 мин» / «меньше минуты» / «—» для пустого времени.
export function formatCallTime(seconds: number): string {
  if (!Number.isFinite(seconds) || seconds <= 0) return '—'
  if (seconds < MINUTE_SECONDS) return 'меньше минуты'
  const hours = Math.floor(seconds / HOUR_SECONDS)
  const minutes = Math.floor((seconds % HOUR_SECONDS) / MINUTE_SECONDS)
  if (hours === 0) return `${minutes} мин`
  return `${hours} ч ${String(minutes).padStart(2, '0')} мин`
}
